import { render, staticRenderFns } from "./AllPushRequests.vue?vue&type=template&id=f9273c62&scoped=true"
import script from "./AllPushRequests.vue?vue&type=script&lang=js"
export * from "./AllPushRequests.vue?vue&type=script&lang=js"
import style0 from "./AllPushRequests.vue?vue&type=style&index=0&id=f9273c62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9273c62",
  null
  
)

export default component.exports